import React from 'react';

const ProfileCompletionBar = ({
  percentage = 0,
  nextHint,
  onCompleteClick,
  compact = false,
}) => {
  const pct = Math.max(0, Math.min(100, Number(percentage) || 0));
  return (
    <div className={`ui-card w-full ${compact ? 'px-4 py-2.5' : 'p-5'}`}>
      <div className={`flex gap-3 ${compact ? 'flex-col sm:flex-row sm:items-center' : 'items-start justify-between'}`}>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-secondary-900">
            Profile strength: {pct}%
          </p>
          {nextHint && pct < 100 && (
            <p className={`text-secondary-600 ${compact ? 'mt-0.5 text-xs sm:truncate' : 'mt-1 text-sm'}`}>{nextHint}</p>
          )}
          {pct >= 100 && (
            <p className={`text-secondary-600 ${compact ? 'mt-0.5 text-xs' : 'mt-1 text-sm'}`}>
              Your profile is ready for better recommendations.
            </p>
          )}
        </div>
        {onCompleteClick && pct < 100 && (
          <button
            type="button"
            onClick={onCompleteClick}
            className={compact ? 'btn-ghost w-full shrink-0 sm:w-auto' : 'btn-primary shrink-0'}
          >
            Complete Profile
          </button>
        )}
      </div>
      <div
        className={`${compact ? 'mt-2 h-1.5' : 'mt-3 h-2'} w-full rounded-full bg-secondary-100 overflow-hidden`}
        role="progressbar"
        aria-label="Profile strength"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-valuetext={`Profile strength ${pct} percent`}
      >
        <div
          className="h-full rounded-full bg-primary-600 transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default ProfileCompletionBar;
